import React from 'react';
import { ARTIFACT_NAMES } from '../copy';
import { changeChip } from './ArtifactCard';
import glance from './glance';

// One saved result at a glance, for a reply that shows several (PRD §6.3):
// its name, key figure, pill or meter, and what changed. The whole tile
// opens the full card in a drawer (onOpen).
export default function ArtifactTile({ artifact, onOpen }) {
  const name = ARTIFACT_NAMES[artifact.kind] || artifact.title;
  const { value, caption, pill, meter } = glance(artifact);
  const delta = changeChip(artifact);

  return (
    <button
      type="button"
      aria-haspopup="dialog"
      aria-label={`${name}: ${[value, caption].filter(Boolean).join(', ')}. Open the full result`}
      data-testid={`artifact-tile-${artifact.kind}`}
      onClick={(event) => onOpen(artifact, event.currentTarget)}
      className="flex flex-col items-start gap-2 w-full min-w-0 text-left bg-card border border-border rounded-xl p-4 cursor-pointer hover:border-succeedo-orange/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-succeedo-orange/50 transition-colors"
    >
      <span className="font-label text-[10px] uppercase tracking-[0.06em] text-muted-foreground truncate max-w-full">{name}</span>
      <span className="text-[20px] font-light leading-tight tracking-[-0.02em] text-foreground tabular-nums">
        {value || artifact.summary}
      </span>
      {pill && (
        <span
          className="inline-flex items-center gap-1.5 font-label text-[10px] tracking-[0.06em] uppercase py-[2px] px-2 rounded-full"
          style={{ background: pill.tint, color: pill.ink }}
        >
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: pill.color }} />
          {pill.label}
        </span>
      )}
      {meter && (
        <span className="block w-full h-1 rounded-full bg-border overflow-hidden" aria-hidden="true">
          <span className={`block h-full rounded-full ${meter.className}`} style={{ width: `${meter.pct}%` }} />
        </span>
      )}
      {caption && <span className="text-[12px] leading-snug text-muted-foreground tabular-nums">{caption}</span>}
      {delta && <span className="font-label text-[10px] text-teal-ink tabular-nums">{delta}</span>}
    </button>
  );
}
